import { api } from './api';

export type ActivityType = 'CALL' | 'MEETING' | 'EMAIL' | 'NOTE' | 'STAGE_CHANGE' | 'ASSIGNMENT';

export interface ActivityDto {
  id: number;
  leadId: number;
  type: ActivityType;
  title: string;
  body: string | null;
  metadata: Record<string, unknown>;
  occurredAt: string;
  createdAt: string;
  user: { id: number; name: string } | null;
}

export interface CreateActivityPayload {
  type: ActivityType;
  title: string;
  body?: string;
  occurredAt?: string;
}

export const activitiesService = {
  async list(leadId: number): Promise<ActivityDto[]> {
    const { data } = await api.get(`/leads/${leadId}/activities`);
    return data.items ?? [];
  },
  async create(leadId: number, payload: CreateActivityPayload): Promise<ActivityDto> {
    const { data } = await api.post(`/leads/${leadId}/activities`, payload);
    return data;
  },
  async remove(id: number): Promise<void> {
    await api.delete(`/activities/${id}`);
  },
};
